
import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

const DisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-bottom: ${size(1.5)};
  gap: ${size(0.5)};
`

const DisplayName = styled.h3`
  margin: 0;
  padding: 0;
  font-size: ${fontSize('lg')};
  font-weight: 700;
  letter-spacing: 0.6px;
`

const Handle = styled.span`
  color: grey;
  font-weight: 600;
  letter-spacing: 0.6px;
  font-size: ${fontSize('sm')};
`

const SpacerDiv = styled.div`
  width: 100%;
  height: ${size(1)};
`

const DrawerDisplayName = ({ user }) => {
  if (user?.isAnonymous || !user?.displayName || !user?.handle) {
    return <SpacerDiv />
  }
  return (
    <DisplayContainer>
      <DisplayName>{user?.displayName}</DisplayName>
      <Handle>{'@' + user?.handle}</Handle>
    </DisplayContainer>
  )
}

export { DrawerDisplayName }
